//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BaseImage from '@/components/common/BaseImage.vue';
import ViewportMixin from '@/mixins/viewport.mixin';

export default {
  components: {
    BaseImage,
  },
  mixins: [ViewportMixin],
  props: {
    // Компактный режим используется в расписании ивента
    // При его активации на мобильных экранах фотография
    // спикера не будет растягиваться на всю ширину
    // Весь текст будет немного меньше
    // А описание спикера будет располагаться в другом месте
    compact: {
      type: Boolean,
      default: false,
    },
    // Если true - не показывать у спикера описание.
    // Только имя и подзаголовок
    hideText: {
      type: Boolean,
      default: false,
    },
    imageConfig: {
      type: Array,
      default: () => [
        { ext: 'webp', sizes: ['100x100 1x', '200x200 2x'] },
        { ext: 'png', sizes: ['100x100 1x', '200x200 2x'] },
      ],
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      unrollable: false,
      unrolled: false,
    };
  },
  computed: {
    unrollTitle() {
      const more = this.$t('eventos.speakers.more');
      const less = this.$t('eventos.speakers.less');
      return this.unrolled ? less : more;
    },
  },
  watch: {
    /** При изменении ширины экрана нужно снова проверить
     *  будет ли на странице кнопка Read More
     */
    isMobile() {
      this.unrolled = false;
      this.checkIsUnrollable();
    },
  },
  mounted() {
    this.checkIsUnrollable();
  },
  methods: {
    /** На телефонах высота описания спикера ограничена четырьмя строками.
     *  Если описание спикера больше четырёх строк - они просто обрезаются
     *  Но на странице появляется кнопка Show More, которая разворачивает
     *  описание полностью
     */
    checkIsUnrollable() {
      let ref = 'text';
      if (this.compact) {
        ref = 'textCompact';
      }

      if (!this.$refs[ref]) return;
      const clientHeight = this.$refs[ref]?.clientHeight;
      const scrollHeight = this.$refs[ref]?.scrollHeight;
      this.unrollable = clientHeight < scrollHeight;
    },
    /** Свернуть или развернуть описание на телефоне.
     *
     *
     */
    toggleUnroll() {
      this.unrolled = !this.unrolled;
      this.updateSwiper();
    },
    /** Каждый раз, когда мы меняем высоту слайдов
     *  нужно обновить состояние свайпера, чтобы высота подстроилась
     */
    updateSwiper() {
      this.$emit('updateHeight');
    },
  },
};
